export const COMPANY = {
  legal: "Aero Soft Solutions Pty Ltd",
  trading: "Aero Soft Solutions",
  abn: "14 702 482 880",
  acn: "702 482 880",
  office: "Level 1, 63-67 Ann St, Surry Hills NSW 2010, Australia",
  tagline: "Specialising in delivering Aviation Solutions at the speed of capability needs.",
};

export const LOGOS = [
  { id: "light", name: "Primary logo", use: "Default for white or light backgrounds.", bg: "#FFFFFF", w: 3273, h: 1152 },
  { id: "dark", name: "Reversed logo", use: "For navy, photographic or other dark backgrounds.", bg: "#0A1B2E", w: 3273, h: 1152 },
  { id: "legal-white", name: "Legal logo, white background", use: "Invoices, letterheads and contracts. Includes Pty Ltd, ABN and ACN.", bg: "#FFFFFF", w: 4329, h: 1248 },
  { id: "legal-transparent", name: "Legal logo, transparent", use: "Same as above, for templates with their own paper colour.", bg: "#F4F9FD", w: 4329, h: 1248 },
  { id: "icon", name: "Icon", use: "Avatars, app icons, favicons, stamps and small spaces.", bg: "#F4F9FD", w: 2048, h: 2048 },
];

export const COLOURS = [
  { name: "Navy Ink", hex: "#0A1B2E", role: "Primary text, wordmark, dark backgrounds" },
  { name: "Aero Blue", hex: "#0B4F8A", role: "Logo mark background" },
  { name: "Horizon Blue", hex: "#0369A1", role: "\"SOLUTIONS\" line, labels, links" },
  { name: "Sky", hex: "#0284C7", role: "Accents and highlights" },
  { name: "Contrail", hex: "#38BDF8", role: "Logo needle, bright accent" },
  { name: "Light Sky", hex: "#7DD3FC", role: "Secondary text on dark backgrounds" },
  { name: "Haze", hex: "#BAE6FD", role: "Rules, dividers, borders" },
  { name: "Sky Wash", hex: "#F4F9FD", role: "Page and panel backgrounds" },
  { name: "Slate", hex: "#334155", role: "Secondary text, legal lines" },
  { name: "White", hex: "#FFFFFF", role: "Backgrounds, reversed text" },
];

export const FONTS = [
  { name: "Familjen Grotesk", role: "Headings and the \"Aero Soft\" wordmark", weights: "SemiBold 600", css: "'Familjen Grotesk', sans-serif", sample: "Aviation solutions at the speed of capability", files: ["FamiljenGrotesk-Variable.ttf", "FamiljenGrotesk-OFL.txt"], gf: "Familjen+Grotesk", weight: 600 },
  { name: "Manrope", role: "Body copy, paragraphs and forms", weights: "Regular 400, Medium 500, SemiBold 600", css: "'Manrope', sans-serif", sample: "Clear, modern text for documents, proposals and correspondence.", files: ["Manrope-Variable.ttf", "Manrope-OFL.txt"], gf: "Manrope", weight: 400 },
  { name: "JetBrains Mono", role: "\"SOLUTIONS\" line, labels, ABN/ACN and reference numbers", weights: "Regular 400, set in capitals with wide letter-spacing", css: "'JetBrains Mono', monospace", sample: "ABN 14 702 482 880 · REF 2026-001", files: ["JetBrainsMono-Variable.ttf", "JetBrainsMono-OFL.txt"], gf: "JetBrains+Mono", weight: 400, upper: true },
  { name: "Instrument Serif", role: "Occasional italic accent word in headlines", weights: "Italic 400", css: "'Instrument Serif', serif", sample: "capability", files: ["InstrumentSerif-Italic.ttf", "InstrumentSerif-Regular.ttf", "InstrumentSerif-OFL.txt"], gf: "Instrument+Serif", weight: 400, italic: true },
];

export const IMAGES = [
  { file: "hero-raaf.jpg", name: "RAAF C-130J and Black Hawk", w: 1264, h: 848 },
  { file: "above.jpg", name: "Above the clouds", w: 1400, h: 1996 },
  { file: "cockpit.jpg", name: "Cockpit", w: 1400, h: 934 },
  { file: "hangar.jpg", name: "Hangar", w: 1400, h: 933 },
];

export const hexToRgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));

// Simple device-independent conversion; printers should proof against HEX/RGB.
export const rgbToCmyk = ([r, g, b]) => {
  const [R, G, B] = [r, g, b].map((v) => v / 255);
  const k = 1 - Math.max(R, G, B);
  if (k >= 1) return [0, 0, 0, 100];
  return [...[R, G, B].map((v) => Math.round(((1 - v - k) / (1 - k)) * 100)), Math.round(k * 100)];
};

export const printMm = (px) => Math.round((px / 300) * 25.4);

export const brandGuideText = () => [
  `${COMPANY.legal} brand kit`,
  "",
  `Legal name: ${COMPANY.legal}`,
  `ABN: ${COMPANY.abn}`,
  `ACN: ${COMPANY.acn}`,
  `Registered office: ${COMPANY.office}`,
  "",
  "COLOURS (HEX | RGB | CMYK approx.)",
  ...COLOURS.map((c) => `${c.name.padEnd(13)} ${c.hex} | RGB ${hexToRgb(c.hex).join(", ")} | CMYK ${rgbToCmyk(hexToRgb(c.hex)).join(", ")} | ${c.role}`),
  "CMYK values are a straight conversion from RGB. Please proof against the HEX/RGB values.",
  "",
  "FONTS (all free under the SIL Open Font License, files in /fonts)",
  ...FONTS.map((f) => `${f.name}: ${f.role} (${f.weights})`),
  "",
  "LOGO FILES",
  "SVG files are vector with text converted to outlines, so no fonts are needed. PNG files are 300 dpi-ready rasters.",
  ...LOGOS.map((l) => `aerosoft-${l.id}: ${l.name}. ${l.use}`),
  "",
  "LOGO USE",
  "Keep clear space around the logo equal to half the height of the icon.",
  "Minimum size: full logo 30 mm wide, icon 8 mm wide.",
  "Do not stretch, rotate, recolour, outline or add effects to the logo.",
].join("\r\n");
